// extracted by mini-css-extract-plugin
export var childWrapper = "tooltip-module--childWrapper--f38c1";
export var content = "tooltip-module--content--67c6d";